import { Resources } from './resources'

class LanguagesResource extends Resources {
  getLanguages () {
    return this.http.get( this.baseUrl )
  }
}

const endPoint = 'https://cheetah-api.builderall.com/api/translate/all'
export default new LanguagesResource( 'languages', endPoint )


// WEBPACK FOOTER //
// ./src/resources/languages.js